import { useMemo, useState, useEffect } from 'react';

const usePagination = (initialData = [], pageSize, initialCurrentPage) => {
  const [currentPageNumber, setCurrentPageNumber] = useState(
    initialCurrentPage ?? 0
  );
  const maxPage = useMemo(() => {
    if (initialData?.length) {
      return Math.ceil(initialData.length / pageSize);
    } else return 0;
  }, [JSON.stringify(initialData), pageSize]);
  const firstIndexOnPage = currentPageNumber * pageSize;

  const shownItems = useMemo(() => {
    return (
      initialData?.slice(
        currentPageNumber * pageSize,
        currentPageNumber * pageSize + pageSize
      ) || []
    );
  }, [JSON.stringify(initialData), pageSize, currentPageNumber]);

  useEffect(() => {
    setCurrentPageNumber(initialCurrentPage ?? 0);
  }, [pageSize, JSON.stringify(initialData)]);

  return [
    currentPageNumber,
    setCurrentPageNumber,
    maxPage,
    shownItems,
    firstIndexOnPage,
  ];
};

export const useDspxTablePagination = ({ items, page, rowPerPage }) => {
  const [pageCount, setPageCount] = useState(0);
  const [displayItems, setDisplayItems] = useState([]);
  const [firstIndex, setFirstIndex] = useState(0);
  const [lastIndex, setLastIndex] = useState(0);

  useEffect(() => {
    let newPageCount;

    if (items?.length && rowPerPage) {
      newPageCount = Math.ceil(items.length / rowPerPage);
    }
    setPageCount(newPageCount ?? 0);
  }, [items, rowPerPage]);

  useEffect(() => {
    let newDisplayItems;

    if (page >= 0 && items?.length && rowPerPage) {
      const start = page * rowPerPage;
      const end = start + rowPerPage;

      newDisplayItems = items.slice(start, end);
    }

    setDisplayItems(newDisplayItems ?? []);
  }, [page, items, rowPerPage]);

  useEffect(() => {
    let newFirstIndex = 0;

    if (page >= 0 && rowPerPage) {
      newFirstIndex = page * rowPerPage;
    }

    setFirstIndex(newFirstIndex);
  }, [page, rowPerPage]);

  useEffect(() => {
    let newLastIndex = 0;
    const count = displayItems.length;

    if (count) {
      newLastIndex = firstIndex + count;
    }

    setLastIndex(newLastIndex);
  }, [displayItems, firstIndex]);

  return {
    pageCount,
    displayItems,
    firstIndex: firstIndex + 1,
    lastIndex,
  };
};

export default usePagination;
